import {
  Alert,
  AlertIcon,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useUpdateRegistry } from "../../../services/api/registries/mutations/useUpdateRegistry";
import { IRegistry, IRegistryUpdate } from "../models/Registry";
import { FormHandle, RegistryForm } from "./RegistryForm";

interface IProps {
  registry: IRegistry;
  isOpen: boolean;
  onClose: () => void;
}

export const EditRegistryModal = ({ onClose, isOpen, registry }: IProps) => {
  const formikRef = React.useRef<FormHandle>(null);

  const {
    mutateAsync: mutateAsyncUpdateRegistry,
    isLoading: isLoadingUpdateRegistry,
    isError: isErrorUpdateRegistry,
  } = useUpdateRegistry();

  const handleOnClose = () => {
    onClose();
  };

  const handleSuccess = () => {
    handleOnClose();
  };

  const handleOnAdd = async (data: IRegistryUpdate) => {
    // Post data to api
    if (data) {
      try {
        await mutateAsyncUpdateRegistry(
          { registryId: registry.id, updateRegistry: data },
          {
            onSuccess: handleSuccess,
          }
        );
      } catch (err) {
        console.log(err);
        // Throw error for downstream form to handle
        throw err;
      }
    }
  };

  const handleOnSubmit = () => {
    if (formikRef) {
      formikRef.current?.submitForm();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      closeOnOverlayClick={true}
      size="3xl"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Registry</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <RegistryForm
              ref={formikRef}
              onSubmit={handleOnAdd}
              registry={registry}
            ></RegistryForm>

            {/* {!isLoadingUpdateRegistry && (
              <HStack spacing={4}>
                <LibFullWidthSpinner size="md" thickness="2px" />
                <Text color="text.softer">Creating registry</Text>
              </HStack>
            )} */}

            {isErrorUpdateRegistry && (
              <Alert status="error" variant={"solid"}>
                <AlertIcon />
                <Text>Failed to edit registry, please refresh</Text>
              </Alert>
            )}
          </Stack>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup isDisabled={isLoadingUpdateRegistry}>
            <Button onClick={onClose}>Close</Button>

            <Button
              type="submit"
              isLoading={isLoadingUpdateRegistry}
              loadingText="Creating registry"
              onClick={handleOnSubmit}
              colorScheme={"primary"}
            >
              Save
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
